/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

module.exports = Odigeo.View.extend({

    renderLoginWelcomeBack: function() {
        this.setTemplate(this.$el, 'membershipLoginWelcomeBack', this.widget.options);
    },
});
